import React, { useEffect } from "react";
import {
  unwrapModSessionPayload,
  useMeritEngineNavigation,
} from "./useMeritEngineNavigation";
import ModDas from "./ModDas";
import ModGridcoPriceAnalysis from "./ModDashboard/LoadPrice";
import GridcoFileUploadTabComponent from "./Resource/Upload/Upload";
import ModGridcoChartTable from "./Mod/ModTable/ModIndex";
import GridcoSellBidTable from "./Bid/BidIndex";
import ModGridcoSimulationIndex from "./ModSimulation/ModSimulationIndex";
import ModGridcoArchive from "./ModArchive/ModArchive";
import ClassesIndex from "./Classes/ClassesIndex";
import BidCreationIndex from "./BidCreation/BidCreationIndex";
import { getModSession } from "../Utility/RestApi";
import { ModCSPDCLSelectedDate } from "../../../store/state/ModCSPDCL/ModDate";
import { setModCSPDCLSession } from "../../../store/state/ModCSPDCL/ModSession";
import { setModCSPDCLVersion } from "../../../store/state/ModCSPDCL/ModVersion";
import { setModCSPDCLSessionToken } from "../../../store/state/ModCSPDCL/ModSessionToken";
import { useDispatch } from "react-redux";

const MeritEngineRouter: React.FC = () => {
  const { currentPage } = useMeritEngineNavigation();
  const dispatch = useDispatch();

  // useEffect to handle page refresh and navigation
  // useEffect(() => {
  //   // This component only renders when currentPage is 'dashboard' or null/undefined
  //   // The MeritEngineRouter handles rendering other pages
  //   // console.log('ModDas rendered with currentPage:', currentPage);
  // }, [currentPage]);

  useEffect(() => {
    async function ModSession() {
      const data = await getModSession();
      const payload = unwrapModSessionPayload(data);
      if (Object.keys(payload).length > 0) {
        if (typeof payload.date === "string") {
          dispatch(ModCSPDCLSelectedDate(payload.date));
        }
        if (payload.session !== undefined && payload.session !== null) {
          dispatch(setModCSPDCLSession(payload.session as any));
        }
        if (payload.version !== undefined && payload.version !== null) {
          dispatch(setModCSPDCLVersion(payload.version as any));
        }
        if (
          payload.session_token !== undefined &&
          payload.session_token !== null
        ) {
          dispatch(setModCSPDCLSessionToken(payload.session_token as any));
        }
      }
    }
    ModSession();
  }, [dispatch]);
  // Render the appropriate component based on the current page
  const renderPage = () => {
    switch (currentPage) {
      case "load-price":
        return <ModGridcoPriceAnalysis />;
      case "resources":
        return <GridcoFileUploadTabComponent />;
      case "merit-order-dispatch":
        return <ModGridcoChartTable />;
      case "classes":
        return <ClassesIndex />;
      case "bid-creation":
        return <BidCreationIndex />;
      case "bid":
        return <GridcoSellBidTable />;
      case "simulation-generation":
        return <ModGridcoSimulationIndex />;
      case "archive":
        return <ModGridcoArchive />;
      case "dashboard":
      case null:
      case undefined:
      default:
        return <ModDas />;
    }
  };

  return <>{renderPage()}</>;
};

export default MeritEngineRouter;
